import JsBarcode from 'jsbarcode';

export interface CodigoBarrasNunota {
    valor: string;
    viewBox: string;
    caminho: string;
}

export function gerarCodigoBarrasNunota(nunota: string): CodigoBarrasNunota | null {
    const valor = nunota.trim();
    if (!/^\d+$/.test(valor) || !/[1-9]/.test(valor)) return null;

    const resultado: {encodings?: Array<{data: string}>} = {};
    JsBarcode(resultado, valor, {format: 'CODE128', displayValue: false});
    const bits = resultado.encodings!.map(encoding => encoding.data).join('');
    // Dez modulos brancos de cada lado preservam a area de leitura do codigo.
    const margem = 10;
    const barras: string[] = [];
    for (let inicio = 0; inicio < bits.length;) {
        if (bits[inicio] !== '1') { inicio++; continue; }
        let fim = inicio + 1;
        while (bits[fim] === '1') fim++;
        barras.push(`M${inicio + margem} 0h${fim - inicio}v24h-${fim - inicio}z`);
        inicio = fim;
    }
    return {valor, viewBox: `0 0 ${bits.length + margem * 2} 24`, caminho: barras.join('')};
}
